export const modalBase = "text-base md:text-lg";
export const modalTitle = "text-xl md:text-2xl font-semibold";
export const labelCls =
  "text-sm md:text-base font-semibold tracking-wide text-slate-500";
export const fieldCls =
  "h-11 md:h-12 px-4 text-base md:text-lg rounded-xl border border-slate-300";
export const btnCls =
  "h-11 md:h-12 px-6 md:px-7 text-base md:text-lg rounded-full";
